/**
 * Utility function untuk insert storelog ke API server.
 * Dipanggil sebelum subscribe RxDB storelog, baik dari SplashScreen maupun ConfirmDialog.
 *
 * @param {Function} hitAPIEC2 - Fungsi hit API dengan Authorization header (dari AuthContext)
 * @param {string} outletId - UUID outlet (partition)
 * @param {string} id - ObjectId unik untuk entry storelog ini
 * @returns {Promise} Response dari API
 */
export const insertMiniappStoreLogUtil = async (hitAPIEC2, outletId, id) => {
  try {
    const INSERT_MINIAPP_STORELOG =
      process.env[`REACT_APP_ENDPOINT_INSERT_MINIAPP_STORELOG_${process.env.REACT_APP_ENV}`];

    const payload = {
      id: id,
      status: 'miniapp_check',
      partition: outletId,
      done: false,
      _deleted: false,
    };

    const response = await hitAPIEC2(INSERT_MINIAPP_STORELOG, 'POST', payload, true);
    return response;
  } catch (error) {
    console.error('Error inserting miniapp storelog:', error);
    throw error;
  }
};
